const NAME = 'emptyset';

const VIEWBOX = '0 0 50 50';

const CONTENTS = `
  <circle cx="25" cy="25" r="15" fill-opacity="0"/>
  <path d="M39.078 6.823l3.596 3.474-4.195 4.345a17.499 17.499 0 012.185 3.752C41.554 20.467 42 22.67 42 25c0 2.331-.445 4.533-1.336 6.606-.89 2.072-2.104 3.877-3.643 5.415-1.538 1.539-3.343 2.753-5.415 3.643C29.533 41.554 27.33 42 25 42c-2.331 0-4.533-.445-6.606-1.336a17.637 17.637 0 01-3.275-1.832l-4.197 4.345-3.596-3.474 4.195-4.344a17.498 17.498 0 01-2.185-3.753C8.446 29.533 8 27.33 8 25c0-2.331.445-4.533 1.336-6.606.89-2.072 2.104-3.877 3.643-5.415 1.538-1.539 3.343-2.753 5.415-3.643C20.467 8.446 22.67 8 25 8c2.331 0 4.533.445 6.606 1.336a17.636 17.636 0 013.275 1.832l4.197-4.345zM34.95 18.296L18.648 35.177c.538.334 1.111.632 1.72.893 1.444.62 2.974.93 4.632.93 1.658 0 3.188-.31 4.632-.93 1.495-.642 2.769-1.499 3.854-2.584s1.942-2.36 2.584-3.854c.62-1.444.93-2.974.93-4.632 0-1.658-.31-3.188-.93-4.632a12.762 12.762 0 00-1.12-2.072zM25 13c-1.658 0-3.188.31-4.632.93-1.495.642-2.769 1.499-3.854 2.584s-1.942 2.36-2.584 3.854C13.31 21.812 13 23.342 13 25c0 1.658.31 3.188.93 4.632.32.744.693 1.434 1.12 2.073l16.303-16.882a12.933 12.933 0 00-1.721-.893C28.188 13.31 26.658 13 25 13z" fill="#757575"/>
`;

const SYMBOL_MARKUP = `<symbol id="tn-syos-seat-map-icon-${NAME}" viewBox="${VIEWBOX}">${CONTENTS}</symbol>`;

function getSvgMarkup(label = 'emptyset') {
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="${VIEWBOX}" role="img" focusable="false" aria-label="${label}">${CONTENTS}</svg>`;
}

export default {
  getSvgMarkup,
  SYMBOL_MARKUP,
};



// WEBPACK FOOTER //
// ./src/syos/seatIcons/EmptySet.js